var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 91,
    viewBox: "0 0 84 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0656 35.2623C86.3665 47.9109 86.3337 67.0388 74.9896 79.6487V79.6487C66.6247 88.947 53.7491 92.764 41.668 89.5269L34.9275 87.7208C23.9236 84.7723 15.0431 76.6528 11.1233 65.9564L1.96343 40.961C-4.15999 24.2514 5.40841 5.8947 22.6132 1.34494V1.34494C33.6062 -1.56212 45.3005 1.94728 52.8765 10.4268L75.0656 35.2623Z",
    fill: "#FF5252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/Shape5.06033390d1ac7163e23e154fcb13e4a7.svg";
export { ForwardRef as ReactComponent };